import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import it from './common/it.js'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 挂载英文文案到全局
Vue.prototype.$it = it;


// 配置谷歌地图
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCBAT-Yn8rMwmYWgPop9Z4CVjRod6yQs_0', // 这只是一个示例密钥，请替换为您自己的密钥
        libraries: 'places', // 可以加载需要的库，如places
        language: 'it' // 设置为意大利文
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
